// Mock data for Saged Recovery and Wellness Collaborative
import cyndiJacobiPhoto from './assets/cyndi_jacobi.jpg';
import mickeyLoewPhoto from './assets/mickey_loew.png';

export const organizationInfo = {
  name: "Saged Recovery and Wellness Collaborative, Inc.",
  mission: "Supporting individuals and families impacted by substance use disorders through compassionate, evidence-based, and peer-driven services.",
  location: "Serving Manistee and Mason Counties, Michigan",
  phone: "",
  email: "info@sagedrecovery.org",
  address: "Serving Manistee and Mason Counties, Michigan"
};

export const services = [
  {
    id: 1,
    title: "Peer Recovery Coaching",
    description: "One-on-one support from certified peer recovery specialists who understand the recovery journey through lived experience.",
    features: ["Individual coaching sessions", "Goal setting and accountability", "Crisis support", "Recovery planning"]
  },
  {
    id: 2,
    title: "Recovery Housing Support",
    description: "Assistance with finding and maintaining stable housing during the recovery process, including transitional housing options.",
    features: ["Housing placement assistance", "Landlord advocacy", "Home readiness support", "Community living skills"]
  },
  {
    id: 3,
    title: "Transportation Services",
    description: "Reliable transportation solutions to remove barriers to treatment, employment, and essential services.",
    features: ["Treatment appointments", "Job interviews", "Essential services", "Community events"]
  },
  {
    id: 4,
    title: "Community Programming",
    description: "Group activities and community-based programs that strengthen recovery networks and build meaningful connections.",
    features: ["Support groups", "Recreational activities", "Educational workshops", "Community events"]
  }
];

export const leadership = [
  {
    id: 1,
    photo: "https://customer-assets.emergentagent.com/job_9835ff48-95e3-43ac-9127-8d3f8ee381f3/artifacts/dvqnqs7b_ChatGPT%20Image%20Jun%201%2C%202026%2C%2010_07_22%20AM.png",
    name: "Kelly Mecham, CADC",
    title: "Founder",
    bio: "Kelly is the Founder of Saged Recovery and Wellness Collaborative, Inc. With over a decade of experience in addiction treatment and recovery leadership, Kelly brings both professional expertise and lived experience to her work. Her career has focused on expanding access to medication-assisted treatment, peer services, and community-based care across rural Michigan.",
    credentials: "CADC",
    longBio: "Kelly's passion for recovery advocacy is deeply personal. In long-term recovery herself, she transformed profound personal loss into purpose, dedicating her life to supporting others on their healing journeys. Her leadership is rooted in compassion, accountability, and empowerment, with a strong commitment to reducing stigma and building recovery-friendly communities. Through Saged, Kelly is building a comprehensive continuum of recovery support that addresses not only sobriety, but housing stability, transportation access, and long-term wellness."
  }
];

export const values = [
  {
    title: "Compassion",
    description: "We approach every individual with empathy, understanding, and respect, recognizing that recovery is a deeply personal journey."
  },
  {
    title: "Evidence-Based Practice",
    description: "Our services are grounded in proven methodologies and best practices in addiction recovery and mental health support."
  },
  {
    title: "Peer-Driven Support",
    description: "We believe in the power of lived experience and peer connections to inspire hope and facilitate lasting recovery."
  },
  {
    title: "Trauma-Informed Care",
    description: "All our services recognize and address the impact of trauma on individuals and families affected by substance use disorders."
  },
  {
    title: "Community Collaboration",
    description: "We work closely with healthcare providers, social services, law enforcement, and community organizations to provide comprehensive support."
  },
  {
    title: "Whole-Person Wellness",
    description: "Recovery encompasses physical, mental, emotional, and spiritual well-being. We address all aspects of an individual's health and wellness."
  }
];

export const impactStats = [
  {
    number: "100%",
    label: "Peer-Driven",
    description: "All coaching services led by certified peer recovery specialists"
  },
  {
    number: "4",
    label: "Core Services",
    description: "Comprehensive recovery support including housing, transportation, and community"
  },
  {
    number: "Virtual",
    label: "Service Model",
    description: "Accessible support across Manistee and Mason Counties"
  },
  {
    number: "NEW",
    label: "Organization",
    description: "Launching innovative recovery support services"
  }
];

export const testimonials = [
  // Removed testimonials as organization is newly launching
];

export const volunteerOpportunities = [
  {
    title: "Peer Recovery Coach",
    description: "Share your recovery experience to support others on their journey. Training, supervision, and background check required. Certification preferred.",
    commitment: "4-6 hours per week",
    activelyRecruiting: true
  },
  {
    title: "Transporter / Driver",
    description: "Provide rides to treatment appointments and essential services. Valid driver's license, clean driving record, proof of auto insurance, and background check required.",
    commitment: "Flexible schedule",
    activelyRecruiting: true
  },
  {
    title: "Event Coordinator",
    description: "Help organize community events and recovery celebrations",
    commitment: "2-4 hours per month"
  },
  {
    title: "Administrative Support",
    description: "Assist with office tasks, data entry, and program coordination",
    commitment: "2-6 hours per week"
  }
];

export const navigationItems = [
  { name: "Home", path: "/" },
  { name: "Programs", path: "/programs" },
  { name: "About", path: "/about" },
  { name: "Board", path: "/board" },
  { name: "Resources", path: "/resources" },
  { name: "Get Involved", path: "/get-involved" },
  { name: "Contact", path: "/contact" }
];

// Board of Directors
export const boardMembers = [
  {
    id: 1,
    photo: "https://customer-assets.emergentagent.com/job_9835ff48-95e3-43ac-9127-8d3f8ee381f3/artifacts/l7gtp0we_NasorBeach25EDIT-2.jpg",
    photoPosition: "center 25%",
    name: "Amanda Nasor",
    title: "Board President",
    bio: "Amanda Nasor serves as Board President of Saged Recovery and Wellness Collaborative. Born and raised in Scottville and rooted in Mason County, Amanda is the Executive Director of Communities Overcoming Violent Encounters (COVE), supporting survivors of intimate partner violence and sexual assault across Mason, Manistee, Oceana, and Lake Counties. She brings deep experience in advocacy, grant writing, fundraising, and lived experience to the board.\n\nAmanda's connection to recovery is deeply personal. She grew up in a family affected by addiction, has faced her own struggles, and has lost three important people in her life to addiction. Through her work with survivors, she sees firsthand how much her community is hurting and how great the need is for accessible support. These experiences fuel her commitment to ensuring that everyone seeking recovery can access help the moment they're ready \u2014 without barriers like housing, transportation, or a lack of services standing in the way.\n\nOutside of this work, Amanda's greatest joy is her family \u2014 her husband, Mo, and their children, Felix and Taj \u2014 whether they're exploring new places or savoring everyday moments together. She is guided by a simple belief: \u201CKindness is courage in action. It takes strength to remain compassionate in a world that often encourages us to do otherwise.\u201D"
  },
  {
    id: 2,
    photo: "https://customer-assets.emergentagent.com/job_9835ff48-95e3-43ac-9127-8d3f8ee381f3/artifacts/ucmpj06i_2008a212-e23e-43cc-b8ee-43d03d5a8a6d.jpg",
    name: "Amanda Koon",
    title: "Secretary",
    bio: "Amanda Koon works with our local community mental health agencies. She is a Licensed Master Social Worker and a Certified Advanced Alcohol and Drug Counselor. With over 10 years of experience in the field of substance use disorders and approximately five years in mental health, Amanda primarily focuses on individuals with co-occurring disorders. In her current role, she works with individuals experiencing severe and persistent mental illness and supports therapists working toward their CAADC certification. Passionate about mentoring and developing clinical staff, she is also a trained Motivational Interviewing trainer dedicated to promoting evidence-based, person-centered approaches in behavioral health care.\n\nAmanda is a person in long-term recovery. She serves on an area nonprofit board for a 12-step community and participates in its regional board meetings. She has been involved in service within the recovery community for 10 years in a variety of roles, has experience as a Recovery Coach, and continues to be involved in the Manistee County Sobriety Court program.\n\nAmanda chose to become involved with Saged not only as a professional in the field, but also as an individual in recovery and an active member of the recovery community \u2014 a perspective that allows her to bring both personal insight and clinical experience to the work. Through her work in the community, she has observed persistent gaps in essential recovery support services, including transportation, after-hours accessibility, and recovery housing. She is truly excited to be part of an organization committed to bridging these critical gaps and enhancing access to comprehensive, person-centered support.\n\nOutside of her work, Amanda finds joy in spending time with her kids and grandkids \u2014 and her favorite place to be is the beach."
  },
  {
    id: 3,
    photo: null,
    name: "Treasurer",
    title: "Open Position",
    bio: "",
    vacant: true
  },
  {
    id: 4,
    photo: mickeyLoewPhoto,
    photoPosition: "center 25%",
    name: "Mickey Loew",
    title: "Board Member",
    bio: "Mickey Loew is a person in long-term recovery, an entrepreneur, and a dedicated advocate for the recovery community in Northwest Michigan. As the owner of multiple businesses throughout Manistee County, Mickey brings a rare combination of lived experience and real-world business acumen to the Saged Recovery and Wellness Collaborative board. He understands firsthand that recovery is not just about getting well, it is about rebuilding a life, and his own journey from recovery to successful business ownership makes him a powerful example of what is possible.\n\nMickey also serves on the sobriety court board, where he works to ensure that people navigating the court system have a genuine path to treatment, accountability, and a second chance. His advocacy is rooted in the belief that people in recovery deserve not only support but real opportunity, and he is deeply committed to strengthening the recovery community he calls home."
  },
  {
    id: 5,
    photo: cyndiJacobiPhoto,
    photoPosition: "center 20%",
    name: "Cyndi Jacobi",
    title: "Board Member & Acting Treasurer",
    bio: "Cyndi Jacobi is a retired Manistee resident who has called the area home for 45 years, bringing deep community roots and lived experience to the Saged board. She has attended numerous conferences on Substance Use Disorder and Harm Reduction, served on the organizing committee for Overdose Awareness Day and the Opioid Symposium, and volunteered with the Harm Reduction Manistee Office (2024\u20132025).\n\nCyndi has held a range of community roles, including board member of the Manistee Community Kitchen, the Michael's Recovery House fundraising committee, and Face Addiction Now (FAN) Manistee/Benzie County. She currently serves as Vice President of the Manistee Friendship Society and as a SEA Manistee committee member.\n\nCyndi joined the Saged Recovery and Wellness Collaborative board because she has seen firsthand the impact addiction can have on individuals and families. After losing her son, JJ, in 2009, she became passionate about learning more and supporting efforts that help others. Her connection to recovery is both personal and ongoing \u2014 she has three family members in recovery whose strength and commitment she deeply admires, and she has watched several of JJ's friends find recovery as well. These experiences have reinforced her belief that recovery is possible and that support and connection matter. As she puts it, \u201CRecovery is not something people should have to face alone.\u201D\n\nFor Manistee and Mason Counties, Cyndi hopes to see greater awareness, less stigma, and more people finding recovery \u2014 making sure everyone knows they are not alone. Outside of this work, she finds joy in time with family, crafts, plants, being on the water or in nature, and traveling. She is guided by a simple belief: \u201CBe kind, for everyone you meet is fighting a battle you know nothing about.\u201D"
  },
  {
    id: 6,
    photo: null,
    name: "Jason Murdey",
    title: "Board Member",
    bio: ""
  }
];

// Hero messaging
export const prelaunchInfo = {
  badge: "Serving Manistee & Mason Counties",
  headline: "Recovery is possible — and you never have to face it alone.",
  message:
    "Saged Recovery and Wellness Collaborative is a nonprofit dedicated to building a stronger, more connected recovery community across Manistee and Mason Counties. We're here to answer your questions, share trusted resources, and connect you with local support. Recovery begins with a single, hopeful step — and we're here to walk it with you.",
  helpNow: [
    {
      title: "Ask Us Anything",
      description:
        "Chat with our friendly virtual assistant any time, or email us directly. We're here to listen and point you in the right direction."
    },
    {
      title: "Find Resources",
      description:
        "Browse trusted recovery, mental health, and crisis resources — available right now, 24/7, whenever you need them."
    },
    {
      title: "Get Connected Locally",
      description:
        "We help connect you with services and support across Manistee and Mason Counties, working alongside trusted local partners."
    }
  ]
};

// Community impact so far
export const impactInfo = {
  stats: [
    { number: "$4,007", label: "Raised at Our Community Auction" },
    { number: "1-on-1", label: "Recovery Support Happening Now" },
    { number: "100s", label: "Community Members Reached" }
  ],
  activities: [
    {
      title: "Community Auction Fundraiser",
      description:
        "Our community showed up in a big way! With a wonderful turnout, our auction raised $4,007.36 to support recovery services in Manistee and Mason Counties."
    },
    {
      title: "4th of July Parade",
      description:
        "We walked in the 4th of July parade, spreading hope and letting our community know that recovery support is here and growing."
    },
    {
      title: "International Overdose Awareness Day",
      description:
        "We're joining local community partners for International Overdose Awareness Day — honoring those we've lost and standing with families and individuals affected by overdose."
    },
    {
      title: "Growing Our Funding",
      description:
        "We're actively pursuing grant funding to expand our programs and bring more recovery support to our region."
    }
  ]
};

// Where we're headed — programs we're working to fund
export const roadmapInfo = {
  title: "Where We're Headed",
  intro:
    "We're actively seeking funding to bring these programs to life across Manistee and Mason Counties. Here's what we're building toward — and the difference it will make.",
  programs: [
    {
      title: "Recovery in Motion",
      description:
        "Peer recovery coaches who walk alongside people in early recovery, plus reliable transportation to treatment and appointments — so getting to help is never the thing standing in the way."
    },
    {
      title: "Recovery Support Services",
      description:
        "Expanded one-on-one recovery coaching, resource navigation, and after-hours support for individuals and families throughout our region."
    },
    {
      title: "Peer Recovery Coach Training",
      description:
        "Certification training for local peer recovery coaches, growing a skilled team with lived experience who understand what recovery really takes."
    },
    {
      title: "Community Support Groups",
      description:
        "Regular, welcoming support groups in both Manistee and Mason Counties where no one has to face recovery alone."
    },
    {
      title: "Recovery Housing",
      description:
        "Exploring safe, supportive housing options so that a stable place to live is part of every recovery journey."
    }
  ],
  membershipNote:
    "Saged Recovery and Wellness Collaborative is a proud member of the Alliance for Recovery Centered Organizations (ARCO), a program of Faces & Voices of Recovery. ARCO membership connects us with a national network of recovery community organizations and reflects our commitment to transparency, accountability, and the highest standards in everything we do.",
  membershipLabel: "Proud ARCO Member",
  certificateFile: "/ARCO_Membership_Certificate.pdf",
  arcoUrl: "https://facesandvoicesofrecovery.org/programs/arco/"
};

// Support group announcement
export const supportGroupAnnouncement = {
  badge: "Coming Soon",
  title: "Support Groups Launching in Manistee & Mason Counties",
  message:
    "We're excited to announce that Saged will be launching recovery support groups in both Manistee and Mason Counties. Details are coming soon — reach out to be the first to know when and where we'll be meeting."
};

// Board meetings & public participation
export const boardMeetingInfo = {
  intro:
    "Our board meetings are open to the community — we'd love to have you there. Attending a meeting is a wonderful way to learn about our work, share your voice during public comment, and show your support for recovery in our region.",
  nextMeeting: {
    date: "Monday, October 26, 2026",
    time: "4:30 PM",
    location: "Virtual meeting via Zoom",
    virtualNote: "A virtual attendance option is available — email us for the link.",
    zoom: {
      url: "https://us05web.zoom.us/j/83241415512?pwd=dJ1aAs3CZhhI9E531QAqvQWYpD1t34.1",
      meetingId: "832 4141 5512",
      passcode: "3RRH41"
    }
  },
  publicComment:
    "Every meeting includes time for public comment. Whether you have ideas, questions, or simply want to show your support, your voice matters to us.",
  minutesNote:
    "Board meeting minutes are posted below following approval at each meeting.",
  minutes: [
    {
      title: "Board Meeting Minutes — September 28, 2026",
      file: "/minutes/Saged_Board_Minutes_September_28_2026.docx"
    },
    {
      title: "Board Meeting Minutes — August 24, 2026",
      file: "/minutes/Saged_Board_Minutes_August_24_2026.docx"
    },
    {
      title: "Board Meeting Minutes — June 29, 2026",
      file: "/minutes/Saged_Board_Minutes_June_29_2026.docx"
    },
    {
      title: "Board Meeting Minutes — June 15, 2026",
      file: "/minutes/Saged_Board_Minutes_June_15_2026.docx"
    },
    {
      title: "Board Meeting Minutes — May 29, 2026",
      file: "/minutes/Saged_Board_Minutes_May_29_2026.docx"
    }
  ]
};

// Donation suggested amounts (must match backend DONATION_PRESETS keys)
export const donationPresets = ["10", "25", "50", "100", "250"];

// Crisis & national resources (verified, always-on support)
export const crisisResources = [
  {
    title: "988 Suicide & Crisis Lifeline",
    description: "Free, confidential support 24/7 for anyone in emotional distress or crisis.",
    action: "Call or text 988",
    href: "tel:988"
  },
  {
    title: "SAMHSA National Helpline",
    description: "Free, confidential, 24/7 treatment referral and information service for substance use and mental health.",
    action: "Call 1-800-662-HELP (4357)",
    href: "tel:18006624357"
  },
  {
    title: "Michigan Peer Warmline",
    description: "Free, confidential peer support staffed by people in recovery. Daily 10am\u20132am ET.",
    action: "Call 1-888-PEER-753 (1-888-733-7753)",
    href: "tel:18887337753"
  },
  {
    title: "Crisis Text Line",
    description: "24/7 support via text message with a trained crisis counselor.",
    action: "Text HOME to 741741",
    href: "sms:741741"
  }
];

// Local & statewide Michigan resources
export const localResources = [
  {
    title: "Michigan 211",
    description:
      "Free statewide service that connects you to local help — food, housing, recovery support, and more. Available 24/7 across Manistee and Mason Counties.",
    action: "Dial 211 or visit mi211.org",
    href: "tel:211"
  },
  {
    title: "Michigan Crisis & Access Line (MiCAL)",
    description:
      "Statewide mental health and substance use crisis support, available any time, day or night.",
    action: "Call 844-446-4225",
    href: "tel:18444464225"
  },
  {
    title: "FindTreatment.gov",
    description:
      "A confidential, anonymous tool from SAMHSA to find substance use and mental health treatment near you.",
    action: "Visit findtreatment.gov",
    href: "https://findtreatment.gov"
  },
  {
    title: "Connect Through Saged",
    description:
      "Not sure where to start? Email us and we'll do our best to point you toward the right local services in Manistee and Mason Counties.",
    action: "Email info@sagedrecovery.org",
    href: "mailto:info@sagedrecovery.org"
  }
];